import React, { useState, useEffect, useContext } from 'react';
import Alert from 'react-s-alert';
import { Tooltip, Modal, ModalBody, ModalHeader, ModalFooter, Button, FormGroup, Label, Col, Input, InputGroup, InputGroupAddon } from 'reactstrap';
import { Link, Prompt } from 'react-router-dom';
import Toggle from 'react-toggle';


// context imports
import { ThemeContext } from '../../contexts/ThemeContext';
import { AuthContext } from '../../contexts/AuthContext';

// service imports
import AuthService from '../../services/AuthService';
import AdminService from '../../services/AdminService';

// local imports



const ProviderSubscriptionPlans = props => {

    // states
    const [providerSubscriptionPlans, setProviderSubscriptionPlans] = useState({
        plans: [],
        planRange: []
    });
    const [editPlanModal, setEditPlanModal] = useState({
        isVisible: false,
        type: "update",
        data: {
            id: '',
            planName: '',
            planServiceDetails: {
                sessionBookingLimit: 0,
                clientLimit: 0,
                createClientSubscriptionPlans: false,
                modeOfServices: {
                    call: false,
                    chat: false,
                    video: false,
                    inPerson: false
                }
            },
            planAmount: 0
        }
    });
    const [removePlanConfirmationModal, setRemovePlanConfirmationModal] = useState({ isVisible: false, selectedIndex: -1 });
    const [isCreatePlanLoading, setIsCreatePlanLoading] = useState(false);
    const [isUpdatePlanLoading, setIsUpdatePlanLoading] = useState(false);
    const [isRemovePlanLoading, setIsRemovePlanLoading] = useState(false);

    // contexts
    const { theme, colors } = useContext(ThemeContext);

    // useEffects
    useEffect(() => {
        getProviderSubscriptionPlans();
    }, []);

    // utility functions
    const getProviderSubscriptionPlans = async () => {
        try {
            let data = await AdminService.getProviderSubscriptionPlans();
            // console.log('data', data);
            let tempArray = [];
            for (let i = data.providerSubscriptionPlanRange.from; i <= data.providerSubscriptionPlanRange.to; i += data.providerSubscriptionPlanRange.interval) {
                tempArray.push(i);
            }
            setProviderSubscriptionPlans({ plans: data.providerSubscriptionPlans, planRange: tempArray });
        } catch (err) {
            console.log(err);
        }
    }

    // handle functions
    const handlePlanDetailChange = e => {
        try {
            e.preventDefault();
            if (e.target.name === 'planName') {
                setEditPlanModal({ ...editPlanModal, data: { ...editPlanModal.data, planName: e.target.value } })
            } else if (e.target.name === 'planAmount') {
                setEditPlanModal({ ...editPlanModal, data: { ...editPlanModal.data, planAmount: e.target.value } })
            } else if (e.target.name === 'sessionBookingLimit') {
                setEditPlanModal({ ...editPlanModal, data: { ...editPlanModal.data, planServiceDetails: { ...editPlanModal.data.planServiceDetails, sessionBookingLimit: e.target.value } } })
            } else if (e.target.name === 'clientLimit') {
                setEditPlanModal({ ...editPlanModal, data: { ...editPlanModal.data, planServiceDetails: { ...editPlanModal.data.planServiceDetails, clientLimit: e.target.value } } })
            } else if (e.target.name === 'createClientSubscriptionPlans') {
                setEditPlanModal({ ...editPlanModal, data: { ...editPlanModal.data, planServiceDetails: { ...editPlanModal.data.planServiceDetails, createClientSubscriptionPlans: e.target.checked } } })
            } else if (e.target.name === 'call') {
                setEditPlanModal({ ...editPlanModal, data: { ...editPlanModal.data, planServiceDetails: { ...editPlanModal.data.planServiceDetails, modeOfServices: { ...editPlanModal.data.planServiceDetails.modeOfServices, call: e.target.checked } } } })
            } else if (e.target.name === 'chat') {
                setEditPlanModal({ ...editPlanModal, data: { ...editPlanModal.data, planServiceDetails: { ...editPlanModal.data.planServiceDetails, modeOfServices: { ...editPlanModal.data.planServiceDetails.modeOfServices, chat: e.target.checked } } } })
            } else if (e.target.name === 'video') {
                setEditPlanModal({ ...editPlanModal, data: { ...editPlanModal.data, planServiceDetails: { ...editPlanModal.data.planServiceDetails, modeOfServices: { ...editPlanModal.data.planServiceDetails.modeOfServices, video: e.target.checked } } } })
            } else if (e.target.name === 'inPerson') {
                setEditPlanModal({ ...editPlanModal, data: { ...editPlanModal.data, planServiceDetails: { ...editPlanModal.data.planServiceDetails, modeOfServices: { ...editPlanModal.data.planServiceDetails.modeOfServices, inPerson: e.target.checked } } } })
            }
        } catch (err) {
            console.log(err);
        }
    }


    const handleCreatePlan = () => {
        setIsCreatePlanLoading(true);
        const { planName, planServiceDetails, planAmount } = editPlanModal.data;
        AdminService.postProviderSubscriptionPlan(planName, planServiceDetails, planAmount)
            .then(data => {
                getProviderSubscriptionPlans();
                setEditPlanModal({
                    isVisible: false,
                    type: "update",
                    data: {
                        id: '',
                        planName: '',
                        planServiceDetails: {
                            sessionBookingLimit: 0,
                            clientLimit: 0,
                            createClientSubscriptionPlans: false,
                            modeOfServices: {
                                call: false,
                                chat: false,
                                video: false,
                                inPerson: false
                            }
                        },
                        planAmount: 0
                    }
                });
                setIsCreatePlanLoading(false);
            })
    }

    const handleUpdatePlan = () => {
        setIsUpdatePlanLoading(true);
        const { id, planName, planServiceDetails, planAmount } = editPlanModal.data;
        AdminService.putProviderSubscriptionPlan(id, planName, planServiceDetails, planAmount)
            .then(data => {
                getProviderSubscriptionPlans();
                setEditPlanModal({
                    isVisible: false,
                    type: "update",
                    data: {
                        id: '',
                        planName: '',
                        planServiceDetails: {
                            sessionBookingLimit: 0,
                            clientLimit: 0,
                            createClientSubscriptionPlans: false,
                            modeOfServices: {
                                call: false,
                                chat: false,
                                video: false,
                                inPerson: false
                            }
                        },
                        planAmount: 0
                    }
                });
                setIsUpdatePlanLoading(false);
            })

    }

    const handleRemovePlan = (index) => {
        setIsRemovePlanLoading(true);
        AdminService.deleteProviderSubscriptionPlan(providerSubscriptionPlans.plans[index]._id)
            .then(data => {
                getProviderSubscriptionPlans();
                setRemovePlanConfirmationModal({ isVisible: false, selectedIndex: -1 });
                setIsRemovePlanLoading(false);
            })
    }

    // functions return
    return (
        <main>
            <div className='container-fluid'>
                <div className='my-4'>
                    <h3 className='my-auto'>Counsellor Subscription Plans</h3>

                    <div className='text-center container mt-5'>
                        <div className='row'>
                            {
                                providerSubscriptionPlans.plans.map((item, index) => (
                                    <div key={index} className="col-8 col-sm-8 col-md-3 text-center px-2 pt-3 m-3" style={theme.card}>
                                        <div style={{ cursor: "pointer", position: "absolute", right: "0.5rem", top: "0.5rem" }}
                                            onClick={() => setEditPlanModal({
                                                isVisible: true,
                                                type: "update",
                                                data: {
                                                    id: item._id,
                                                    planName: item.name,
                                                    planServiceDetails: {
                                                        sessionBookingLimit: item.serviceDetails.sessionBookingLimit,
                                                        clientLimit: item.serviceDetails.clientLimit,
                                                        createClientSubscriptionPlans: item.serviceDetails.createClientSubscriptionPlans,
                                                        modeOfServices: {
                                                            call: item.serviceDetails.modeOfServices.call,
                                                            chat: item.serviceDetails.modeOfServices.chat,
                                                            video: item.serviceDetails.modeOfServices.video,
                                                            inPerson: item.serviceDetails.modeOfServices.inPerson
                                                        }
                                                    },
                                                    planAmount: item.amount
                                                }
                                            })}>
                                            <i className="fas fa-edit" style={{ color: colors.primary }}></i>
                                        </div>
                                        <h2 style={Object.assign({ color: "#384E73" }, theme.subHeadingSemibold)}>{item.name}</h2>
                                        <p>{`₹${item.amount / 100} / Month`}</p>
                                        <div>
                                            <p><i className='fas fa-check mr-2'></i>Upto {item.serviceDetails.sessionBookingLimit} Sessions</p>
                                            <p><i className='fas fa-check mr-2'></i>Upto {item.serviceDetails.clientLimit} Clients</p>
                                            <p><i className={`fas fa-${item.serviceDetails.modeOfServices.call > 0 ? 'check' : 'times danger_text_color'} mr-2`}></i>Call</p>
                                            <p><i className={`fas fa-${item.serviceDetails.modeOfServices.chat > 0 ? 'check' : 'times danger_text_color'} mr-2`}></i>Chat</p>
                                            <p><i className={`fas fa-${item.serviceDetails.modeOfServices.video > 0 ? 'check' : 'times danger_text_color'} mr-2`}></i>Video</p>
                                            <p><i className={`fas fa-${item.serviceDetails.modeOfServices.inPerson > 0 ? 'check' : 'times danger_text_color'} mr-2`}></i>In Person</p>
                                            <p><i className={`fas fa-${item.serviceDetails.createClientSubscriptionPlans > 0 ? 'check' : 'times danger_text_color'} mr-2`}></i>Create Client Subscription Plans</p>
                                        </div>
                                        <p style={{ color: colors.danger, fontSize: '1.2rem', cursor: "pointer" }} onClick={() => setRemovePlanConfirmationModal({ isVisible: true, selectedIndex: index })}>
                                            Remove
                                        </p>
                                    </div>
                                ))
                            }
                            {
                                providerSubscriptionPlans.plans.length < 3 ?
                                    <div className="d-flex col-8 col-sm-8 col-md-3 text-center px-2 py-3 m-3" style={Object.assign({ cursor: "pointer" }, theme.card)}
                                        onClick={() => setEditPlanModal({
                                            isVisible: true,
                                            type: "create",
                                            data: {
                                                id: '',
                                                planName: '',
                                                planServiceDetails: {
                                                    sessionBookingLimit: 0,
                                                    clientLimit: 0,
                                                    createClientSubscriptionPlans: false,
                                                    modeOfServices: {
                                                        call: false,
                                                        chat: false,
                                                        video: false,
                                                        inPerson: false
                                                    }
                                                },
                                                planAmount: 0
                                            }
                                        })}>
                                        <div className="m-auto">
                                            <div className="d-flex">
                                                <div>
                                                    <h2 style={{ color: "#384E73", fontFamily: "Montserrat, sans-serif", fontSize: "3rem", fontWeight: "600" }}>{`+`}</h2>
                                                </div>
                                                <div>
                                                    <h2 style={Object.assign({ color: "#384E73" }, theme.subHeadingSemibold)}>{`Add plan`}</h2>
                                                    <p>{`${3 - providerSubscriptionPlans.plans.length} left`}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    : null
                            }
                        </div>
                    </div>

                </div>


                {/* Remove Plan Confirmation Modal */}
                <Modal size="sm" isOpen={removePlanConfirmationModal.isVisible} backdrop={true}>
                    <ModalHeader close={<span className="ml-3" style={{ cursor: "pointer" }} onClick={() => setRemovePlanConfirmationModal({ isVisible: false, selectedIndex: -1 })}><i className="fas fa-times"></i></span>}><span style={theme.headingBold}>Are you sure?</span></ModalHeader>
                    <ModalBody>
                        {
                            removePlanConfirmationModal.selectedIndex >= 0 ?
                                <Label>By clicking on Remove button <b>{providerSubscriptionPlans.plans[removePlanConfirmationModal.selectedIndex].name}</b> plan will be <b>Deleted</b>.</Label>
                                : null
                        }
                    </ModalBody>
                    <ModalFooter>
                        <Button type="button" style={theme.formButtonDanger} onClick={() => handleRemovePlan(removePlanConfirmationModal.selectedIndex)}>
                            {isRemovePlanLoading ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Remove
                        </Button>
                    </ModalFooter>
                </Modal>

                {/* Create / Update Plan Confirmation Modal */}
                <Modal size="lg" isOpen={editPlanModal.isVisible} backdrop={true}>

                    <ModalHeader close={<span className="ml-3" style={{ cursor: "pointer" }}
                        onClick={() => setEditPlanModal({
                            isVisible: false,
                            type: "update",
                            data: {
                                id: '',
                                planName: '',
                                planServiceDetails: {
                                    sessionBookingLimit: 0,
                                    clientLimit: 0,
                                    createClientSubscriptionPlans: false,
                                    modeOfServices: {
                                        call: false,
                                        chat: false,
                                        video: false,
                                        inPerson: false
                                    }
                                },
                                planAmount: 0
                            }
                        })}>
                        <i className="fas fa-times"></i></span>}><span style={theme.headingBold}>Edit plan</span>
                    </ModalHeader>


                    <ModalBody>
                        <div className="text-center">
                            <div className="d-inline-block col-8 col-sm-8 col-md-4 text-center px-2 py-3 m-3" style={theme.card}>
                                <h2 style={Object.assign({ color: "#384E73" }, theme.subHeadingSemibold)}>{editPlanModal.data.planName}</h2>
                                <p>{`₹${editPlanModal.data.planAmount / 100} / Monthly`}</p>
                                <div>
                                    <p><i className='fas fa-check mr-2'></i>Upto {editPlanModal.data.planServiceDetails.sessionBookingLimit} Sessions</p>
                                    <p><i className='fas fa-check mr-2'></i>Upto {editPlanModal.data.planServiceDetails.clientLimit} Clients</p>
                                    <p><i className={`fas fa-${editPlanModal.data.planServiceDetails.modeOfServices.chat > 0 ? 'check' : 'times danger_text_color'} mr-2`}></i>Chat</p>
                                    <p><i className={`fas fa-${editPlanModal.data.planServiceDetails.modeOfServices.video > 0 ? 'check' : 'times danger_text_color'} mr-2`}></i>Video</p>
                                    <p><i className={`fas fa-${editPlanModal.data.planServiceDetails.modeOfServices.inPerson > 0 ? 'check' : 'times danger_text_color'} mr-2`}></i>In Person</p>
                                    <p><i className={`fas fa-${editPlanModal.data.planServiceDetails.createClientSubscriptionPlans > 0 ? 'check' : 'times danger_text_color'} mr-2`}></i>Create Client Subscription Plans</p>
                                </div>
                            </div>
                        </div>


                        <div className="p-3 m-3" style={theme.card}>
                            <FormGroup row>
                                <Label sm={4} for="planName">Plan name</Label>
                                <Col sm={8}>
                                    <Input type="text" name="planName" id="planName" value={editPlanModal.data.planName} onChange={handlePlanDetailChange} required />
                                </Col>
                            </FormGroup>

                            <FormGroup row>
                                <Label sm={4} for="planAmount">Rate</Label>
                                <Col sm={8}>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">₹</InputGroupAddon>
                                        <Input type="select" name="planAmount" id="planAmount" value={editPlanModal.data.planAmount} onChange={handlePlanDetailChange} required>
                                            <option value="">Select amount</option>
                                            {
                                                providerSubscriptionPlans.planRange.map((item, index) => (
                                                    <option key={index} value={item * 100}>{item}</option>
                                                ))
                                            }
                                        </Input>
                                    </InputGroup>
                                </Col>
                            </FormGroup>

                            <FormGroup row>
                                <Label sm={4} for="sessionBookingLimit">Session Booking Limit</Label>
                                <Col sm={8}>
                                    <Input type="text" name="sessionBookingLimit" id="sessionBookingLimit" value={editPlanModal.data.planServiceDetails.sessionBookingLimit} onChange={handlePlanDetailChange} required />
                                </Col>
                            </FormGroup>

                            <FormGroup row>
                                <Label sm={4} for="clientLimit">Client Limit</Label>
                                <Col sm={8}>
                                    <Input type="text" name="clientLimit" id="clientLimit" value={editPlanModal.data.planServiceDetails.clientLimit} onChange={handlePlanDetailChange} required />
                                </Col>
                            </FormGroup>

                            <FormGroup row>
                                <Label sm={4} for="call">Call</Label>
                                <Col sm={8}>
                                    <Toggle
                                        id="call"
                                        name="call"
                                        icons={false}
                                        checked={editPlanModal.data.planServiceDetails.modeOfServices.call}
                                        onChange={handlePlanDetailChange}
                                    />
                                </Col>
                            </FormGroup>

                            <FormGroup row>
                                <Label sm={4} for="chat">Chat</Label>
                                <Col sm={8}>
                                    <Toggle
                                        id="chat"
                                        name="chat"
                                        icons={false}
                                        checked={editPlanModal.data.planServiceDetails.modeOfServices.chat}
                                        onChange={handlePlanDetailChange}
                                    />
                                </Col>
                            </FormGroup>

                            <FormGroup row>
                                <Label sm={4} for="video">Video</Label>
                                <Col sm={8}>
                                    <Toggle
                                        id="video"
                                        name="video"
                                        icons={false}
                                        checked={editPlanModal.data.planServiceDetails.modeOfServices.video}
                                        onChange={handlePlanDetailChange}
                                    />
                                </Col>
                            </FormGroup>

                            <FormGroup row>
                                <Label sm={4} for="inPerson">In Person</Label>
                                <Col sm={8}>
                                    <Toggle
                                        id="inPerson"
                                        name="inPerson"
                                        icons={false}
                                        checked={editPlanModal.data.planServiceDetails.modeOfServices.inPerson}
                                        onChange={handlePlanDetailChange}
                                    />
                                </Col>
                            </FormGroup>

                            <FormGroup row>
                                <Label sm={4} for="createClientSubscriptionPlans">Create Client Subscription Plans</Label>
                                <Col sm={8}>
                                    <Toggle
                                        id="createClientSubscriptionPlans"
                                        name="createClientSubscriptionPlans"
                                        icons={false}
                                        checked={editPlanModal.data.planServiceDetails.createClientSubscriptionPlans}
                                        onChange={handlePlanDetailChange}
                                    />
                                </Col>
                            </FormGroup>

                        </div>
                    </ModalBody>
                    <ModalFooter className="justify-content-start">
                        {
                            editPlanModal.type === "update" ?
                                <Button type="button" style={theme.formButton} className="btn" onClick={() => handleUpdatePlan()}>
                                    {isUpdatePlanLoading ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}{"Update plan"}
                                </Button>
                                : <Button type="button" style={theme.formButton} className="btn" onClick={() => handleCreatePlan()}>
                                    {isCreatePlanLoading ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}{"Add plan"}
                                </Button>
                        }
                    </ModalFooter>
                </Modal>

            </div>
        </main>
    )


}


export default ProviderSubscriptionPlans;
